import { render, staticRenderFns } from "./CostOverrun.vue?vue&type=template&id=edd9daa4"
import script from "./CostOverrun.vue?vue&type=script&lang=js"
export * from "./CostOverrun.vue?vue&type=script&lang=js"
import style0 from "./CostOverrun.vue?vue&type=style&index=0&id=edd9daa4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports